export enum EnMaterialIcon {
  check = 'check',
  warning = 'warning',
  error = 'error',
  error_outline = 'error_outline',
  contact_support = 'contact_support',
  contact_phone = 'contact_phone'
}
